import React, { Component } from 'react';
import Button from '../../../components/button/Button';
import Toast from '../../../components/toast/Toast';
import InputItem from '../../../components/input-item/InputItem';
import { alterIPAdress } from '../../../service/command';

export default class AlterIP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '修改IP',
      ip: '117.60.157.137:5683'
    };
  }

  onConfirm() {
    const { title, ip } = this.state;
    const loading = Toast.loading(`正在${title}`);
    alterIPAdress(ip).then(() => {
      Toast.success(`${title}成功`);
    }).catch((error) => {
      Toast.fail(error);
    }).then(() => {
      loading.destroy();
    });
  }

  onChange(e) {
    this.setState({
      ip: e.target.value
    });
  }

  render() {
    const { title, ip } = this.state;

    return (
      <div>
        <h4 className="popup-title">{title}</h4>
        <InputItem
          readOnly
          label="ip地址:"
          value={ip}
          onChange={this.onChange}
        />
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Button type="primary" onClick={() => this.onConfirm()}>{title}</Button>
        </div>
      </div>
    );
  }
}
